import { UserSource } from "./source";
import { BaseProfile, IProfile } from "./profiles";
import { getUser, UserNotification } from "./index";
import { Application, Profile as ISSOApiProfile } from "@eres/ssoapi/entities";
import { SSO_USER } from "./roles";

export interface ISSOProfile extends ISSOApiProfile, IProfile {

}

export class SSOProfile extends BaseProfile implements ISSOProfile {
	applications?: Application[];
	email?: string;
	emiratesId: string;
	fullName?: string;
	fullNameAr?: string;
	mobileNumber?: string;
	userAccountIDs?: string[];
	notifications?: UserNotification[];
	selectedUserAccountId?: string;
	loginMethod?: string;

	constructor( profile: ISSOProfile ) {
		super( UserSource.SSO, profile.emiratesId );
		this.refreshRoles();
		this.applications = profile.applications;
		this.emiratesId = profile.emiratesId;
		this.email = profile.email;
		this.fullName = profile.fullName;
		this.fullNameAr = profile.fullNameAr;
		this.mobileNumber = profile.mobileNumber ? profile.mobileNumber.replace( /[^\d]/g, "" ) : undefined;
		this.userAccountIDs = profile.userAccountIDs;
		this.notifications = profile.notifications ?? [];
		this.selectedUserAccountId = profile.selectedUserAccountId;
		this.loginMethod = profile.loginMethod;
	}

	static buildProfile( profile: ISSOProfile ): SSOProfile {
		const p = new SSOProfile( profile );
		return p;
	}

	static getProfile(): SSOProfile | undefined {
		const u = getUser();
		if ( u )
			return u.getProfile( UserSource.SSO ) as SSOProfile;
		return undefined;
	}

	static getParticipantId(): number | undefined {
		return undefined;
	}

	static getEmiratesId(): string | undefined {
		const p = SSOProfile.getProfile();
		if ( p ) return p.emiratesId;
		return undefined;
	}

	refreshRoles() {
		super.refreshRoles();
		if ( !this.hasRole( SSO_USER ) ) this.addRole( SSO_USER );
	}
}
